"use client"

import { createContext, useContext, useState, useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { fetchCurrentUser } from "../redux/slices/authSlice"

const AuthContext = createContext()

export function AuthProvider({ children }) {
  const dispatch = useDispatch()
  const reduxUser = useSelector((state) => state.auth.user)
  const reduxIsAuthenticated = useSelector((state) => state.auth.isAuthenticated)
  const authBootstrapped = useSelector((state) => state.auth.authBootstrapped)
  const [user, setUser] = useState(null)
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    dispatch(fetchCurrentUser())
  }, [dispatch])

  useEffect(() => {
    if (authBootstrapped) {
      setUser(reduxIsAuthenticated ? reduxUser : null)
      setIsLoading(false)
    }
  }, [authBootstrapped, reduxIsAuthenticated, reduxUser])

  const setAuthenticatedUser = (nextUser) => {
    setUser(nextUser)
  }

  const logout = () => {
    setUser(null)
  }

  const value = {
    user,
    logout,
    isAuthenticated: !!user,
    isLoading,
    setAuthenticatedUser,
  }

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>
}

export const useAuth = () => {
  const context = useContext(AuthContext)
  if (context === undefined) {
    throw new Error("useAuth must be used within an AuthProvider")
  }
  return context
}
